function e(l) {
  var n;
  if (l == null || l.value == null) return null;
  let u = (n = l.value.$el) != null ? n : l.value;
  return u instanceof Node ? u : null;
}
export {
  e as dom
};
